import { convertToCurrency } from "utils/string";

export const billingAmountRow = (billing, code) => {
  const value = billing?.find((item) => item?.code === code)?.amount;

  return convertToCurrency(value);
};

export const getBillingCodes = (data) => {
  const newArray = data
    ?.filter((item) => item?.code && item?.display === true)
    .map((item) => item?.code);

  const filteredData = [...new Set(newArray)];

  return filteredData;
};
